import {call, put,takeLatest} from 'redux-saga/effects'
import * as cartService from "../../../services/cartService"

import {
    DECREASE_CART_COUNT,
    DECREASE_CART_COUNT_SUCCESS,
    DECREASE_CART_COUNT_ERROR
}
    from "../../actions/cart";

function* decreaseCartCountSaga(action) {
    try {
        const data=yield call(cartService.DecreaseCartCount,action.payload)
        yield put({
            type: DECREASE_CART_COUNT_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: DECREASE_CART_COUNT_ERROR,error: error.data
        })
    }
}


export function* decreaseCartCountSagaWatcher() {
    yield takeLatest(DECREASE_CART_COUNT,decreaseCartCountSaga);
}